import { EditableText } from '@smartfire/components';
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import Button from '../button/block';
import { Skeleton } from '../shared/components/skeleton';
import { PublicationTile } from '../shared/publicationTile';
import style from './block.module.scss';

const ListCategories = ({ selectedCategory, setSelectedCategory }) => {
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        apiFetch({
            path: 'smartfire-publication-categories/v1/get',
        }).then((res) => {
            setCategories(res);
            setLoadingCategories(false);
        });
    }, []);

    return !loadingCategories && categories && categories.length > 0 ? (
        <ul className={style.categories}>
            <li className={clsx(style.category, !selectedCategory && style.current)}>
                <button className={style.btn} onClick={() => setSelectedCategory(null)}>
                    Tous
                </button>
            </li>
            {categories.map((category) => (
                <li
                    key={'cat_' + category.term_id}
                    className={clsx(style.category, selectedCategory === category.term_id && style.current)}
                >
                    <button className={style.btn} onClick={() => setSelectedCategory(category.term_id)}>
                        {category.name}
                    </button>
                </li>
            ))}
        </ul>
    ) : (
        <ul className={style.categories}>
            {Array.from(new Array(categories.length || 3)).map((n, i) => (
                <li key={'load_' + i} className={style.category}>
                    <Skeleton className={style.skeleton} />
                </li>
            ))}
        </ul>
    );
};

const ListingPublications = () => {
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);
    const [end, setEnd] = useState(false);

    useEffect(() => {
        setPosts([]);
        setPage(1);
    }, [selectedCategory]);

    useEffect(() => {
        setLoading(true);

        let params = {
            per_page: 12,
            page: page,
        };

        if (selectedCategory) {
            params.category = selectedCategory;
        }

        apiFetch({ path: 'smartfire-publication/v1/get?' + new URLSearchParams(params).toString(), parse: false }).then(
            (res) => {
                res.json().then((data) => {
                    setPosts((posts) => posts.concat(data));
                    setEnd(data.length < 12);
                    setLoading(false);
                });
            },
        );
    }, [setPosts, page, selectedCategory]);

    const loadMore = () => {
        setPage(page + 1);
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.head}>
                <EditableText className={style.pretitle} smartProp={'pretitle'} tagName={'p'} />
                <EditableText className={style.title} smartProp={'title'} tagName={'h2'} />
            </div>

            <div className={style.container}>
                <ListCategories selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />

                <div className={style.grid}>
                    {!loading && posts
                        ? posts.map((post, index) => (
                              <div key={index}>
                                  <PublicationTile post={post} />
                              </div>
                          ))
                        : Array.from(new Array(4)).map((_, index) => (
                              <Skeleton
                                  className={style.skeleton}
                                  key={'skeleton_' + index}
                                  width={'100%'}
                                  height={440}
                              />
                          ))}
                </div>

                {!end && (
                    <Button
                        text={'Voir plus'}
                        type={'filled'}
                        align={'center'}
                        onClick={loadMore}
                        showInspector={false}
                    />
                )}
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: ListingPublications,
    smartProps: {
        pretitle: smartProps.string.withDefault('À lire'),
        title: smartProps.string.withDefault("Les publications d'Arcachon"),
    },
    setup: {
        title: 'Liste publications',
    },
});
